import React, { useEffect, useState } from 'react';

import CartApi from '../../api/cart';
import analytics from '../../analytics';
import SideMenu from '../../navigation/side-menu';
import Rejoiner from '../../api/rejoiner';
import CartHandler from '../../cart-popup/cart-handler';

import transformItems from './transform-items';

export const CartContext = React.createContext({});

export const UPSELL_PRODUCTS = [
  45185068007593, // +Caffeine Shot Green Apple
  45185080000681, // +Caffeine Shot Peach
  45185080197289 // No Caffeine Shot Peach
];

const cartApi = new CartApi();
const sideMenu = new SideMenu();
const rejoiner = new Rejoiner();
const cartHandler = new CartHandler();

const CartContextProvider = ({ children }) => {
  const [cart, setCart] = useState(null);

  const closeCart = () => {
    sideMenu.hide('cart-popup-container');
  };

  const updateCartData = ({ data }) => {
    analytics.googleTagCart({ cartData: data });
    setCart({ ...data, items: transformItems({ items: data.items }) });
    cartHandler.handle({ itemCount: data.item_count });
  };

  const fetchCart = async () => {
    const { data } = await cartApi.getCartData();
    updateCartData({ data });
    rejoiner.handleChange({ cartData: data });
  };

  const addItem = async ({ quantity, variantId, isSubscription }) => {
    await cartApi.addCartItem({ quantity, variantId, isSubscription });

    fetchCart();
  };

  const removeItem = async ({ key }) => {
    const { data } = await cartApi.removeCartItem({ key: String(key) });
    const upsellProducts = data.items.filter(({ id }) => UPSELL_PRODUCTS.includes(id));
    const baseProducts = data.items.filter(({ id }) => !UPSELL_PRODUCTS.includes(id));

    if (baseProducts.length === 0 && upsellProducts.length > 0) {
      await cartApi.removeBundle({ items: upsellProducts });
    }

    fetchCart();
  };

  const updateItem = async ({
    quantity,
    variantId,
    key,
    isSubscription
  }) => {
    const { data } = await cartApi.changeCartItem({
      id: String(key),
      variantId,
      quantity,
      isSubscription
    });

    updateCartData({ data });

    if (quantity === 0) {
      rejoiner.handleRemove({ variantId, cartData: data });
    } else {
      rejoiner.handleChange({ cartData: data });
    }
  };

  const toggleSubscription = async ({ item, isSubscription }) => {
    const params = {
      key: item.key,
      variantId: item.variant_id,
      quantity: item.quantity,
      isSubscription
    };

    await updateItem(params);
  };

  useEffect(() => {
    document.addEventListener('open-cart', fetchCart);

    fetchCart();
  }, []);

  return (
    <CartContext.Provider
      value={{
        cart,
        addItem,
        removeItem,
        fetchCart,
        toggleSubscription,
        updateItem,
        closeCart,
        updateCartData
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartContextProvider;
